// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__RrUui","containerItemsCenter":"Skeleton_containerItemsCenter__3nXAd"};